<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 3h11M6.5 21h11M7 3c0 4.2 3.6 6.3 5 9-1.4 2.7-5 4.8-5 9M17 3c0 4.2-3.6 6.3-5 9 1.4 2.7 5 4.8 5 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
